import React, { createContext, useEffect, useState, useContext } from "react";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { db } from "./firebase"; 

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(undefined); // undefined = loading, null = no user
  const [currentUserProfile, setCurrentUserProfile] = useState(null);
  const [authLoading, setAuthLoading] = useState(true);

  const auth = getAuth();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (firebaseUser) => {
      setAuthLoading(true);

      // Ingen användare inloggad
      if (!firebaseUser) {
        setUser(null);
        setCurrentUserProfile(null);
        setAuthLoading(false);
        return;
      }

      setUser(firebaseUser);

      try {
        // 1. Hämta tenantId via global index
        const indexRef = doc(db, "userTenantIndex", firebaseUser.uid);
        const indexSnap = await getDoc(indexRef);

        if (!indexSnap.exists()) {
          console.error("No tenant index found for user:", firebaseUser.uid);
          setCurrentUserProfile(null);
          setAuthLoading(false);
          return;
        }

        const { tenantId } = indexSnap.data();

        // 2. Hämta användarprofil under rätt tenant
        const userRef = doc(db, "tenants", tenantId, "users", firebaseUser.uid);
        const userSnap = await getDoc(userRef);

        if (!userSnap.exists()) {
          console.error("No user profile found for user:", firebaseUser.uid);
          setCurrentUserProfile(null);
          setAuthLoading(false);
          return;
        }

        const userData = userSnap.data();

        setCurrentUserProfile({
          uid: firebaseUser.uid,
          tenantId,
          ...userData,
        });
      } catch (error) {
        console.error("Error loading user profile:", error);
        setCurrentUserProfile(null);
      }

      setAuthLoading(false);
    });

    return () => unsubscribe();
  }, []);

  return (
    <AuthContext.Provider
      value={{
        user,
        currentUserProfile,
        authLoading,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);